<template>
  	<v-app>
		<v-overlay :value="!app.theme_loaded" v-if="!isRecordingRole()">
			<v-progress-circular
				v-if="app.room.settings != null && !youtbe_auth_complete"
				indeterminate
				size="64"
			></v-progress-circular>
			<v-btn v-else-if="youtube_auth_window && youtbe_auth_complete" @click="closeWindow()">Close</v-btn>
			<div v-else class="text-h5 text--disabled font-weight-bold">No Room Found</div>
		</v-overlay>

		<meeting-system-bar v-if="app.theme_loaded"></meeting-system-bar>
		<meeting-navigation-drawer v-if="app.theme_loaded && meeting.is_connected && !isRecordingRole()"></meeting-navigation-drawer>
		<v-main v-if="app.theme_loaded" :class="getBackgroundClass">
			<!-- <v-container fluid class="fill-height"> -->
				<router-view></router-view>
			<!-- </v-container> --> 
		</v-main>
		
		<v-bottom-navigation v-model="menu" v-if="!meeting.leaving && app.theme_loaded && $route.name == 'Meeting' && !isRecordingRole()" :style="`padding-right:${meeting.show_nav_drawer ? meeting.sidebar_width : '0'}px`" grow>
			<v-btn @click="meeting.hmsActions.setLocalAudioEnabled(!meeting.local_audio_enabled)">
				<span>{{ meeting.local_audio_enabled ? 'Mute' : 'Unmute' }}</span>
				<v-icon>{{ meeting.local_audio_enabled ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
			</v-btn>

			<v-divider vertical></v-divider>
			<v-btn @click="meeting.hmsActions.setLocalVideoEnabled(!meeting.local_video_enabled)">
				<span>{{ meeting.local_video_enabled ? 'Hide' : 'Unhide' }}</span>
				<v-icon>{{ meeting.local_video_enabled ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
			</v-btn>

			<!-- <v-divider vertical class="d-none d-sm-flex"></v-divider>

			<v-btn @click="meeting.toggle_blur = true" class="d-none d-sm-flex">
				<span>Blur</span>
				<v-icon>{{meeting.blur_on ? 'mdi-blur' : 'mdi-blur-off'}}</v-icon>
			</v-btn> -->

			<!-- SCREENSHARE -->
			<template v-if="meeting.is_connected && (meeting.local_peer.roleName == 'host' || meeting.isScreenSharingEnabled)">
				<v-divider vertical v-if="meeting.is_connected" class="d-none d-sm-flex"></v-divider>
				<v-btn @click="meeting.is_local_screen_shared || meeting.is_whiteboard_active || meeting.video_playlist.length > 0 || meeting.audio_playlist.length > 0 ? toggleScreenshare() : show_share_dialog = true" class="d-none d-sm-flex"
					:color="meeting.is_local_screen_shared || meeting.is_whiteboard_active || meeting.video_playlist.length > 0 || meeting.audio_playlist.length > 0 ? 'red' : ''"
				>
					<span>Share</span>
					<v-icon>mdi-monitor-share</v-icon>
				</v-btn>
			</template>

			
			<!-- CO-BROWSE -->
			<!-- <v-divider vertical v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" class="d-none d-sm-flex"></v-divider>
			<template v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'">
				<v-divider vertical v-if="meeting.is_connected" class="d-none d-sm-flex"></v-divider>
				<v-btn @click="toggleCobrowse()" class="d-none d-sm-flex" :color="meeting.isCobrowsing() ? 'red' : ''">
					<span>Co-browse</span>
					<v-icon>mdi-account-supervisor</v-icon>
				</v-btn>
			</template> -->


			<!-- WHITEBOARD -->
			<!-- <v-divider vertical v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" class="d-none d-sm-flex"></v-divider>
			<template v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'">
				<v-divider vertical v-if="meeting.is_connected" class="d-none d-sm-flex"></v-divider>
				<v-btn @click="toggleWhiteboard()" class="d-none d-sm-flex" :color="meeting.is_whiteboard_active ? 'red' : ''">
					<span>Whiteboard</span>
					<v-icon>mdi-human-male-board</v-icon>
				</v-btn>
			</template> -->

                        
			<!-- RECORDING -->
			<v-divider vertical v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" class="d-none d-sm-flex"></v-divider>
			<v-btn :loading="meeting.recording_starting" v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" @click="toggleRecord()" class="d-none d-sm-flex" :class="{'red': isRecording}">
				<span>Record</span>
				<v-icon>mdi-record-circle-outline</v-icon>
			</v-btn>
			
			<!-- LIVESTREAM -->
			<template v-if="user.hasRole('administrator') || user.userdata && user.userdata.allcaps && user.userdata.allcaps.manage_livestream">
				<v-divider vertical v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" class="d-none d-sm-flex"></v-divider>
				<v-btn :loading="livestream_starting" v-if="meeting.is_connected && meeting.local_peer.roleName == 'host'" 
					@click="meeting.livestream_state.running ? toggleLivestream() : show_livestream_dialog = true" class="d-none d-sm-flex" :class="`${meeting.livestream_state.running ? 'red' : ''}`">
					<span>Livestream</span>
					<v-icon>mdi-broadcast</v-icon>
				</v-btn>
			</template>

			
			<v-divider vertical v-if="meeting.is_connected" class="d-none d-sm-flex"></v-divider>

			<v-btn v-if="meeting.is_connected"  class="d-none d-sm-flex"
				@click="() => {
					meeting.participants_chat_switch = 'participants'
					meeting.show_nav_drawer = true
				}">
				<span>{{meeting.peers.filter(peer => ['guest', 'host'].includes(peer.roleName) || (['guest', 'host', 'coach'].includes(peer.roleName) && meeting.local_peer.roleName != 'guest')).length}}</span>
				<v-icon>mdi-account</v-icon>
			</v-btn>

			<v-divider vertical v-if="meeting.is_connected"></v-divider>
			<v-btn v-if="meeting.is_connected" @click="() => {
					meeting.participants_chat_switch = 'chat'
					meeting.show_nav_drawer = true
				}">
				<span>Chat</span>
				<v-badge v-if="meeting.new_message_count > 0" color="success" :content="meeting.new_message_count"><v-icon>mdi-message</v-icon></v-badge>
				<v-icon v-else>mdi-message</v-icon>
			</v-btn>

			<v-divider vertical></v-divider>
			<v-btn @click="meeting.show_settings = true">
				<span>Settings</span>
				<v-icon>mdi-cog</v-icon>
			</v-btn>

			<!-- LEAVE -->
			<v-divider vertical v-if="meeting.is_connected"></v-divider>
			<v-btn v-if="meeting.is_connected" color="red" @click="leave()">
				<v-icon>mdi-logout</v-icon>
			</v-btn>

			<!-- <v-divider vertical v-if="meeting.is_connected"></v-divider>
			<v-btn v-if="meeting.is_connected" @click="sendMetaData()">
				<v-icon>mdi-check</v-icon>
			</v-btn> -->



		</v-bottom-navigation>

		<v-overlay :value="starting_cobrowse || ending_cobrowse">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-dialog v-model="show_cobrowse_dialog" maxWidth="600">
			<v-card>
				<v-card-title>
					Begin Co-browsing Session
				</v-card-title>
				<v-card-text>
					You can share and collaborate on almost any webpage with other users. Enter a website URL to get started.
					<v-text-field outlined v-model="cobrowse_url" label="Enter a URL" class="mt-4"></v-text-field>
					<v-sheet v-if="cobrowse_urls.length > 0" max-height="300" class="overflow-y-auto pa-2" outlined>
						<v-list>
							<v-list-item-group
								v-model="selected_url"
							>
								<template v-for="url in cobrowse_urls">
									<v-list-item :key="url">
										<template v-slot:default>
											<v-list-item-content>
												<v-list-item-title v-text="url"
													@click="cobrowse_url = url"
												></v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<v-btn icon @click="removeUrlHistory(url)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</v-list-item-action>
										</template>
									</v-list-item>
								</template>
							</v-list-item-group>
						</v-list>
					</v-sheet>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="show_cobrowse_dialog = false">Cancel</v-btn>
					<v-btn color="primary" @click="startCobrowse()">Start Co-browsing Session</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="show_end_cobrowse_dialog" maxWidth="500">
			<v-card>
				<v-card-title>End Co-browsing Session?</v-card-title>
				<v-card-text>
					Are you sure you want to end your co-browsing session?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="show_end_cobrowse_dialog = false">Close</v-btn>
					<v-btn color="red" @click="endCobrowse()">Stop Co-browsing</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


		<v-dialog v-model="show_whiteboard_dialog" maxWidth="500">
			<v-card>
				<v-card-title>
					Begin Whiteboard Session
				</v-card-title>
				<v-card-text>
					Enter the URL of your whiteboard app (i.e. Miro.com) to share it in the meeting.
					<v-text-field outlined v-model="meeting.whiteboard_url" label="Enter a URL" class="mt-4"></v-text-field>
					<v-sheet v-if="whiteboard_urls.length > 0" max-height="300" class="overflow-y-auto pa-2" outlined>
						<v-list>
							<v-list-item-group v-model="selected_url">
								<template v-for="url in whiteboard_urls">
									<v-list-item :key="url">
										<template v-slot:default>
											<v-list-item-content>
												<v-list-item-title v-text="url"
													@click="meeting.whiteboard_url = url"
												></v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<v-btn icon @click="removeUrlHistory(url)">
													<v-icon>mdi-close</v-icon>
												</v-btn>
											</v-list-item-action>
										</template>
									</v-list-item>
								</template>
							</v-list-item-group>
						</v-list>
					</v-sheet>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="show_whiteboard_dialog = false">Cancel</v-btn>
					<v-btn color="primary" @click="startWhiteboardSession()">Start Whiteboard Session</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- LIVESTREAM DIALOG -->
		<v-dialog v-model="show_livestream_dialog" maxWidth="400">
			<v-card>
				<v-card-title>
					<v-row>
						<v-col class="grow">
							<v-icon class="mr-2" color="red">mdi-broadcast</v-icon>
							Livestreaming
						</v-col>
						<v-col class="shrink">
							<v-btn icon @click="show_livestream_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
						</v-col>
					</v-row>
				</v-card-title>
				<v-card-text class="pt-6">
					
					<!-- WEBINAR LIVESTREAM -->
					<!-- <v-card class="d-flex rounded-lg my-4" outlined>
						<v-card flat class="pa-2 align-self-center"> Webinar Mode </v-card>
						<v-card flat class="pa-2 ml-auto">
							<v-switch class="mt-0" dense hide-details></v-switch>
						</v-card>
					</v-card> -->

					<!-- RECORDING -->
					<!-- <v-card class="d-flex rounded-lg my-4" outlined>
						<v-card flat class="pa-2 align-self-center"> Record </v-card>
						<v-card flat class="pa-2 ml-auto">
							<v-switch class="mt-0" dense hide-details v-model="record_livestream"></v-switch>
						</v-card>
					</v-card> -->

					<!-- FACEBOOK/YOUTUBE/RTMP -->
					<!-- <v-card class="d-flex rounded-lg my-4" outlined>
						<v-card class="pa-2 align-self-center"> Facebook/Youtube/RTMP </v-card>
						<v-card class="pa-2 ml-auto">
							<v-switch class="mt-0" dense hide-details></v-switch>
						</v-card>
					</v-card> -->
					<!-- <v-card class="rounded-lg my-4 pa-4" outlined> -->
						<!-- <v-card class="d-flex mb-4" flat>
							<v-card flat class="align-self-center"> Facebook/Youtube/RTMP </v-card>
							<v-card flat dense class="ml-auto">
								<v-switch class="mt-0 mr-0" dense hide-details></v-switch>
							</v-card>
						</v-card> -->
						<v-text-field outlined label="Title" dense hide-details required v-model="livestream_title" class="mb-2" :error-messages="livestream_title_errors"></v-text-field>
						<v-textarea outlined rows="3" dense hide-details label="Description" v-model="livestream_description" class="my-1"></v-textarea>

						<p>Privacy Status:</p>
						<v-radio-group
							v-model="livestream_privacy"
							row
							mandatory
						>
							<v-radio
								label="Public"
								value="public"
							></v-radio>
							<v-radio
								label="Unlisted"
								value="unlisted"
							></v-radio>
							<v-radio
								label="Private"
								value="private"
							></v-radio>
						</v-radio-group>

						<v-btn v-if="meeting.livestream_state.running" color="red" @click="toggleLivestream(true)" block :loading="meeting.rtmp_stopping">
							<v-icon class="mr-2">mdi-youtube</v-icon>
							Stop Livestream
						</v-btn>
						<v-btn v-else color="red" @click="createLiveBroadcast()" block :loading="meeting.rtmp_starting || connecting_to_youtube">
							<v-icon class="mr-2">mdi-youtube</v-icon>
							Start Youtube Livestream
						</v-btn>
						<div class="text-center">{{ meeting.livestream_state.running ? "Livestreaming" : livestream_status_message }}</div>
						<div class="text-center my-2">
							<small>VIPHuddles.com's use and transfer of information received from Google APIs 
								to any other app will adhere to 
								<a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank">
									Google API Services User Data Policy
								</a>, 
								including the Limited Use requirements.<br /><br />
								VIPHuddles.com <a href="https://viphuddles.com/privacy-policy/" target="_blank">Privacy Policy</a>
							</small>
						</div>

						<!-- disabling direct input for now -->
						<!-- <div>RTMP Stream 1</div>
						<v-text-field dense hideDetails outlined class="my-4" v-model="rtmp[0].url" label="RTMP Url"></v-text-field>
						<v-text-field dense hideDetails outlined class="my-4" v-model="rtmp[0].key" label="Stream Key"></v-text-field> -->
						
						<!-- <div class="mt-4">RTMP Stream 2</div>
						<v-text-field dense hideDetails outlined class="my-4" v-model="rtmp[1].url" label="RTMP Url"></v-text-field>
						<v-text-field dense hideDetails outlined class="my-4" v-model="rtmp[1].key" label="Stream Key"></v-text-field> -->
					<!-- </v-card> -->
					<div class="error"></div>
					
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="show_share_dialog" maxWidth="400">

			<v-card>
				<v-card-title>
					<v-row>
						<v-col class="grow">
							<v-icon class="mr-2" color="red">mdi-monitor-share</v-icon>
							Share Content
						</v-col>
						<v-col class="shrink">
							<v-btn icon @click="show_share_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
						</v-col>
					</v-row>
				</v-card-title>
				<v-card-text class="pt-6">

					<v-row>
						<v-col cols="12" class="pb-6">
							<v-btn block color="primary" @click="toggleScreenshare()" x-large class="mb-4">Screen</v-btn>
							<v-btn block color="primary" @click="toggleWhiteboard()" x-large class="mb-4">Whiteboard</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">Share a Video</v-col>
						<v-col cols="8">
							<v-file-input v-model="video_file" outlined accept="video/*" label="Video file" dense></v-file-input>
						</v-col>
						<v-col cols="4">
							<v-btn @click="shareVideo()" block color="primary">Share</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">Share Audio</v-col>
						<v-col cols="8">
							<v-file-input v-model="audio_file" outlined accept="audio/*" label="Audio file" dense></v-file-input>
						</v-col>
						<v-col cols="4">
							<v-btn @click="shareAudio()" block color="primary">Share</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

  	</v-app>
</template>

<script>
import MeetingSystemBar from './components/MeetingSystemBar.vue'
import MeetingNavigationDrawer from './components/MeetingNavigationDrawer.vue'
import { useMeetingStore } from './stores/meeting'
import { useUserStore } from './stores/user'
import { useAppStore } from './stores/app'
import { 
	selectPeerMetadata, 
	selectIsLocalScreenShared, 
	selectRecordingState,
	// HMSPlaylistItem, 
	HMSPlaylistType,
} from '@100mslive/hms-video-store'
// import { GlobalHandlers } from '@sentry/vue'

export default {
	name: 'AppMeeting',
	components: {
		MeetingSystemBar,
		MeetingNavigationDrawer
	},
	created() {
		this.meeting = useMeetingStore()
		this.user = useUserStore()
		this.app = useAppStore()

		// Add window beforeunload handler
		window.addEventListener('beforeunload', this.handleBeforeUnload)

		this.app.checkOutseta()
	},
	data() {
		return {
			app: null,
			menu: null,
			user:  null,
			meeting: null,
			cobrowse_url:"",
			selected_url: "",
			cobrowse_urls: [],
			whiteboard_urls: [],
			ending_cobrowse: false,
			starting_cobrowse: false,
			// recording_starting: false,
			livestream_starting: false,
			show_cobrowse_dialog: false,
			show_whiteboard_dialog: false,
			show_end_cobrowse_dialog: false,
			livestream_status_message: "",
			show_livestream_dialog: false,
			livestream_privacy: 'private',
			connecting_to_youtube: false,
			livestream_title_errors: "",
			youtbe_auth_complete: false,
			youtube_auth_window: false,
			livestream_description: "",
			show_share_dialog: false,
			record_livestream: false,
			livestream_title: "",
			video_file: null,
			audio_file: null,
			broadcast_it: "",
			access_token: "",
			rtmp:[
				{ url: "", key: "" },
				{ url: "", key: "" },
			],
			mediaRecorder: null,
			recordedChunks: [],
			isRecording: false,
			recorderWindow: null,
		}
	},
	computed: {
		getBackgroundClass: function() {
			if(this.$vuetify.theme.themes.dark.background && this.$vuetify.theme.themes.dark.background != '')
				return 'background'
			return ''
		},
	},
	mounted: async function() {
		await this.user.fetchUser()
		if(typeof this.user.userdata.rtmp != 'string') {
			this.rtmp = { ...this.rtmp, ...this.user.userdata.rtmp }
		}

		// if the code and/or state param is in the URL then this is someone being redirected from the Google/Youtube Oauth process
		// We just need to send this to the back end for processing and then have them close the window
		if(window.location.search.indexOf('&code=') > -1) {
			this.youtube_auth_window = true
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			this.app.get('youtube/connect?code='+urlParams.get('code')+"&state="+urlParams.get('state'))
			.then(response => {
				this.youtbe_auth_complete = true
				window.close()
			})
		// } else if(window.location.search.indexOf('?code=') > -1) {
		// 	//get the HighLevel access tokens and save to this account
		// 	let url = new URL(window.location.href);
		// 	let params = new URLSearchParams(url.search);
		// 	let code = params.get('code');
		// 	this.app.getHighLevelTokens(code)
		// 	this.loadRoom()
		} else {
			this.loadRoom()
		}
		// this.getCobrowseUrlHistory()

		let whiteboardScript = document.createElement('script')
		whiteboardScript.setAttribute('src', 'https://www.whiteboard.team/dist/api.js')
		document.head.appendChild(whiteboardScript)

		// hmsStore.subscribe(recording_state => {
		// 	console.log("record state updated", recording_state)
		// }, selectRecordingState)
		// this.meeting.hmsStore.subscribe(recording_state => {
        //     console.log("recording state updated2", recording_state)
        //     this.meeting.recording_state = recording_state
        // }, selectRecordingState)
	},
	methods: {
		shareVideo: function() {
			var videoUrl = URL.createObjectURL(this.video_file);
			this.meeting.hmsActions.videoPlaylist.setList([{
						url: videoUrl,
						id: 'myvideo',
						name: 'VIP Huddles Overview',
						type: HMSPlaylistType.video,
			}])
			this.meeting.hmsActions.videoPlaylist.play('myvideo')
			this.show_share_dialog = false
		},
		shareAudio: function() {
			var audioUrl = URL.createObjectURL(this.audio_file);
			this.meeting.hmsActions.audioPlaylist.setList([{
				url: audioUrl,
				id: 'myaudio',
				name: 'VIP Huddles Audio',
				type: HMSPlaylistType.audio,
			}])
			this.meeting.hmsActions.audioPlaylist.play('myaudio')
			this.show_share_dialog = false
		},
		closeWindow: function() {
			window.close()
		},
		isRecordingRole: function() {
			if(!this.meeting.local_peer)
				return false
			return ['record', 'record-guest'].includes(this.meeting.local_peer.roleName)
		},
		removeUrlHistory: function(remove_url) {
			let cobrowse_url_history = window.localStorage.getItem('cobrowse_url_history') ?? '[]'
			let urls = JSON.parse(cobrowse_url_history)
			let newUrls = urls.filter(url => {
				return url != remove_url
			})
			window.localStorage.setItem('cobrowse_url_history', JSON.stringify(newUrls))
			this.getCobrowseUrlHistory()
			// setTimeout(() => {
			// 	this.getCobrowseUrlHistory()
			// }, 100)
		},
		getCobrowseUrlHistory: function() {
			let cobrowse_url_history = window.localStorage.getItem('cobrowse_url_history') ?? '[]'
			let urls = JSON.parse(cobrowse_url_history)
			this.cobrowse_urls = urls.sort()
		},
		getWhiteboardUrlHistory: function() {
			let whiteboard_url_history = window.localStorage.getItem('whiteboard_url_history') ?? '[]'
			let urls = JSON.parse(whiteboard_url_history)
			this.whiteboard_urls = urls.sort()
		},
		toggleMicrophone: function() {
			
		},
		async toggleRecord() {
			console.log("=== toggleRecord started ===");
			
			// If already recording, stop it
			if (this.isRecording) {
				console.log("Stopping recording...");
				if (this.recorderWindow && !this.recorderWindow.closed) {
					this.recorderWindow.postMessage({ action: 'stopRecording' }, '*');
				} else {
					this.isRecording = false;
				}
				return;
			}

			// Create popup window for recording controls - Make it full screen
			const width = Math.min(600, window.screen.width); // 500px or screen width, whichever is smaller
			const height = Math.min(700, window.screen.height); // 500px or screen height, whichever is smaller
			const left = window.screen.width / 2 - width / 2; // Center horizontally
			const top = window.screen.height / 2 - height / 2; // Center vertically
			
			// Clean up previous recorder window and event listeners
			if (this.recorderWindow && !this.recorderWindow.closed) {
				this.recorderWindow.close();
			}
			
			// Remove any existing message event listener
			window.removeEventListener('message', this.handleRecorderMessage);
			
			// Set up communication with the popup - IMPORTANT: Bind the handler to this
			window.addEventListener('message', this.handleRecorderMessage.bind(this));
			
			// Make room_id available to the recorder window through window.opener
			window.room_id = this.app.room.ID;
			console.log("Setting window.room_id =", window.room_id);
			
			// Create a simple recorder popup with basic HTML
			const queryParams = `?room_id=${this.app.room.ID}&session_id=local-recording-${Date.now()}`;
			const popupOptions = `width=${width},height=${height},left=${left},top=${top},resizable=no`;
			
			// Use a blank HTML page with query parameters
			this.recorderWindow = window.open(`about:blank${queryParams}`, 'Recording', popupOptions);
			
			if (!this.recorderWindow) {
				this.app.showError("Unable to open recording window. Please allow popups for this site.");
				return;
			}
			
			// Create a very basic HTML structure
			this.recorderWindow.document.write('<html><head><title>Recording</title></head><body></body></html>');
			this.recorderWindow.document.close();
			
			// Pass room_id to the recorder window
			this.recorderWindow.room_id = this.app.room.ID;
			console.log("Setting this.recorderWindow.room_id =", this.recorderWindow.room_id);
			
			// Get document references
			const doc = this.recorderWindow.document;
			const body = doc.body;
			
			// Add styles
			const style = doc.createElement('style');
			style.textContent = `
				body { 
					font-family: Arial, sans-serif; 
					padding: 20px; 
					text-align: center;
					background: #f5f5f5;
					margin: 0;
					display: flex;
					flex-direction: column;
					height: 100vh;
					justify-content: center;
				}
				.header {
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 20px;
				}
				.status {
					margin: 15px 0;
					font-size: 14px;
					color: #555;
				}
				button {
					padding: 10px 20px;
					border-radius: 4px;
					cursor: pointer;
					font-weight: bold;
					border: none;
					outline: none;
					margin: 5px;
					transition: all 0.3s;
				}
				#startBtn {
					background: #4CAF50;
					color: white;
				}
				#helpBtn {
					background: #2196F3;
					color: white;
				}
				#stopBtn {
					background: #f44336;
					color: white;
					display: none;
				}
				.timer {
					font-size: 18px;
					margin: 10px 0;
					font-weight: bold;
					display: none;
				}
				#errorMessage {
					color: red;
					margin-top: 10px;
				}
				.instructions {
					text-align: left;
					margin: 15px 0;
					padding: 10px;
					background: #fff;
					border-radius: 4px;
					border: 1px solid #ddd;
				}
				.instructions ol {
					padding-left: 25px;
					margin: 10px 0;
				}
				.instructions li {
					margin-bottom: 8px;
				}
				.important {
					color: #f44336;
					font-weight: bold;
				}
				.skip-option {
					margin-top: 15px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.help-modal {
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: rgba(0,0,0,0.8);
					display: none;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					z-index: 100;
					padding: 20px;
				}
				.help-content {
					background: white;
					padding: 20px;
					border-radius: 4px;
					max-width: 90%;
					max-height: 90%;
					overflow: auto;
					text-align: left;
				}
				.help-image {
					max-width: 100%;
					margin: 10px 0;
				}
				.close-help {
					align-self: flex-end;
					color: white;
					font-size: 24px;
					cursor: pointer;
					margin-bottom: 10px;
				}
			`;
			doc.head.appendChild(style);
			
			// Create UI elements
			const header = doc.createElement('div');
			header.className = 'header';
			header.textContent = 'Recording Setup';
			body.appendChild(header);
			
			const instructions = doc.createElement('div');
			instructions.className = 'instructions';
			instructions.innerHTML = `
				<p>Follow these steps to record your meeting:</p>
				<ol>
					<li>Click "Start Recording" below</li>
					<li>In the popup dialog, select <span class="important">"Meeting Room Tab"</span></li>
					<li><span class="important">Make sure "Share tab audio" is enabled</span> (blue toggle)</li>
					<li>Click the "Share" button to begin recording</li>
				</ol>
				<p>Need help? <a href="#" id="showHelpLink">Click here for visual instructions</a></p>
			`;
			body.appendChild(instructions);
			
			const skipOption = doc.createElement('div');
			skipOption.className = 'skip-option';
			const skipCheckbox = doc.createElement('input');
			skipCheckbox.type = 'checkbox';
			skipCheckbox.id = 'skipNextTime';
			const skipLabel = doc.createElement('label');
			skipLabel.htmlFor = 'skipNextTime';
			skipLabel.textContent = ' Skip instructions next time';
			skipLabel.style.marginLeft = '5px';
			skipOption.appendChild(skipCheckbox);
			skipOption.appendChild(skipLabel);
			body.appendChild(skipOption);
			
			const statusMessage = doc.createElement('p');
			statusMessage.className = 'status';
			statusMessage.id = 'statusMessage';
			statusMessage.textContent = 'Ready to record';
			body.appendChild(statusMessage);
			
			const recordingTimer = doc.createElement('div');
			recordingTimer.className = 'timer';
			recordingTimer.id = 'recordingTimer';
			recordingTimer.textContent = '00:00';
			body.appendChild(recordingTimer);
			
			const startBtn = doc.createElement('button');
			startBtn.id = 'startBtn';
			startBtn.textContent = 'Start Recording';
			body.appendChild(startBtn);
			
			const stopBtn = doc.createElement('button');
			stopBtn.id = 'stopBtn';
			stopBtn.textContent = 'Stop & Save';
			stopBtn.style.display = 'none';
			body.appendChild(stopBtn);
			
			const errorMessage = doc.createElement('div');
			errorMessage.id = 'errorMessage';
			body.appendChild(errorMessage);
			
			// Create help modal
			const helpModal = doc.createElement('div');
			helpModal.className = 'help-modal';
			helpModal.id = 'helpModal';
			
			const closeHelp = doc.createElement('div');
			closeHelp.className = 'close-help';
			closeHelp.textContent = '✕';
			closeHelp.onclick = () => {
				helpModal.style.display = 'none';
			};
			helpModal.appendChild(closeHelp);
			
			const helpContent = doc.createElement('div');
			helpContent.className = 'help-content';
			helpContent.innerHTML = `
				<h3>How to Share Your Meeting Tab</h3>
				<p>When you click "Start Recording", you'll see a screen like this:</p>
				<img src="/wp-content/plugins/viphuddles/assets/images/Recording Meeting Room Selection.png" class="help-image" alt="Recording selection guide">
				<p>Important steps:</p>
				<ol>
					<li>Select "Chrome Tab" option</li>
					<li>Click on the meeting tab from the list</li>
					<li>Make sure "Share tab audio" is toggled on (blue)</li>
					<li>Click "Share" to begin recording</li>
				</ol>
			`;
			helpModal.appendChild(helpContent);
			body.appendChild(helpModal);
			
			// Get the current selected microphone from the meeting store
			const selectedMicrophone = this.meeting.hmsStore.getState(state => {
				return state.settings.audioInputDeviceId;
			});
			
			// Add the recording functionality with enhanced audio handling
			const recorderScript = doc.createElement('script');
			recorderScript.textContent = `
				// Define variables without 'let' or 'const' for access in subsequent recordings
				var mediaRecorder = null;
				var recordedChunks = [];
				var timerInterval = null;
				var startTime = 0;
				var audioContext = null;
				var microphoneSource = null;
				var tabAudioSource = null;
				var audioDestination = null;
				var outputStream = null;
				var displayStream = null;
				var microphoneStream = null;
				var isRecording = false;
				
				// Store the selected microphone device ID from the meeting
				const selectedMicrophoneId = "${selectedMicrophone || ''}";
				
				// Check if user has chosen to skip instructions
				const shouldSkipNextTime = localStorage.getItem('skipRecordingInstructions') === 'true';
				
				// Show the help modal when link is clicked
				document.getElementById('showHelpLink').addEventListener('click', function(e) {
					e.preventDefault();
					document.getElementById('helpModal').style.display = 'flex';
				});
				
				// Save skip preference
				document.getElementById('skipNextTime').addEventListener('change', function() {
					localStorage.setItem('skipRecordingInstructions', this.checked);
				});
				
				// Check saved preference
				if (shouldSkipNextTime) {
					document.getElementById('skipNextTime').checked = true;
				}
				
				function updateTimer() {
					if (!startTime) return;
					const elapsed = Math.floor((Date.now() - startTime) / 1000);
					const minutes = Math.floor(elapsed / 60).toString().padStart(2, "0");
					const seconds = (elapsed % 60).toString().padStart(2, "0");
					document.getElementById("recordingTimer").textContent = minutes + ":" + seconds;
				}
				
				function startTimer() {
					document.getElementById("recordingTimer").style.display = "block";
					startTime = Date.now();
					timerInterval = setInterval(updateTimer, 1000);
					updateTimer();
				}
				
				function stopTimer() {
					if (timerInterval) {
						clearInterval(timerInterval);
						timerInterval = null;
					}
				}
				
				// Function to clean up resources
				function cleanup() {
					if (displayStream) {
						displayStream.getTracks().forEach(track => track.stop());
						displayStream = null;
					}
					if (microphoneStream) {
						microphoneStream.getTracks().forEach(track => track.stop());
						microphoneStream = null;
					}
					if (audioContext) {
						audioContext.close();
						audioContext = null;
					}
					if (mediaRecorder && mediaRecorder.state !== "inactive") {
						try {
							mediaRecorder.stop();
						} catch (err) {
							console.error("Error stopping media recorder:", err);
						}
					}
					mediaRecorder = null;
					recordedChunks = [];
					isRecording = false;
					
					// Reset UI elements
					document.getElementById("startBtn").style.display = "block";
					document.getElementById("stopBtn").style.display = "none";
					document.getElementById("recordingTimer").style.display = "none";
				}
				
				// Function to mix tab audio and microphone audio
				async function createMixedStream(tabStream, micStream) {
					// Create audio context for mixing
					audioContext = new (window.AudioContext || window.webkitAudioContext)();
					
					// Create destination for mixed audio
					audioDestination = audioContext.createMediaStreamDestination();
					
					// Connect tab audio if available
					if (tabStream && tabStream.getAudioTracks().length > 0) {
						tabAudioSource = audioContext.createMediaStreamSource(new MediaStream([tabStream.getAudioTracks()[0]]));
						tabAudioSource.connect(audioDestination);
						console.log("Tab audio connected to mixer");
					} else {
						console.log("No tab audio tracks available");
					}
					
					// Connect microphone audio if available
					if (micStream && micStream.getAudioTracks().length > 0) {
						microphoneSource = audioContext.createMediaStreamSource(micStream);
						microphoneSource.connect(audioDestination);
						console.log("Microphone audio connected to mixer");
					} else {
						console.log("No microphone audio tracks available");
					}
					
					// Create a final stream with video from display capture and mixed audio
					const tracks = [];
					
					// Add video track from the display capture
					if (tabStream && tabStream.getVideoTracks().length > 0) {
						tracks.push(tabStream.getVideoTracks()[0]);
					}
					
					// Add the mixed audio tracks from the destination
					audioDestination.stream.getAudioTracks().forEach(track => {
						tracks.push(track);
					});
					
					return new MediaStream(tracks);
				}
				
				// Define the startRecording function that will be called when user clicks the button
				async function startRecording() {
					try {
						// Reset state from previous recording if any
						cleanup();
						
						document.getElementById("statusMessage").textContent = "Waiting for screen selection...";
						
						// 1. Capture the display (screen, window, or tab)
						displayStream = await navigator.mediaDevices.getDisplayMedia({
							video: {
								displaySurface: "browser",
								frameRate: { ideal: 30 },
								width: { ideal: 1920 },
								height: { ideal: 1080 }
							},
							audio: true  // Request tab audio
						});
						
						if (!displayStream.getVideoTracks().length) {
							throw new Error("No video track available");
						}
						
						// 2. Capture the microphone audio
						try {
							// Use the same microphone that's selected in the meeting if available
							const audioConstraints = {
								audio: {
									echoCancellation: true,
									noiseSuppression: true
								}
							};
							
							// If we have a selected microphone, use that specific device
							if (selectedMicrophoneId) {
								audioConstraints.audio.deviceId = { exact: selectedMicrophoneId };
							}
							
							microphoneStream = await navigator.mediaDevices.getUserMedia(audioConstraints);
							console.log("Microphone access granted");
						} catch (audioErr) {
							console.warn("Microphone access failed:", audioErr);
							// Try without device constraint if the specific device failed
							if (selectedMicrophoneId) {
								try {
									microphoneStream = await navigator.mediaDevices.getUserMedia({
										audio: {
											echoCancellation: true,
											noiseSuppression: true
										}
									});
									console.log("Fallback microphone access granted");
								} catch (fallbackErr) {
									console.warn("Fallback microphone also failed:", fallbackErr);
								}
							}
						}
						
						// Log audio track status
						console.log("Display audio tracks:", displayStream.getAudioTracks().length);
						console.log("Microphone audio tracks:", microphoneStream ? microphoneStream.getAudioTracks().length : 0);
						
						// 3. Mix the audio streams and create a combined stream
						const combinedStream = await createMixedStream(displayStream, microphoneStream);
						
						// 4. Find the best supported MIME type
						let mimeType = "video/webm;codecs=vp9,opus";
						if (!MediaRecorder.isTypeSupported(mimeType)) {
							mimeType = "video/webm;codecs=vp8,opus";
							if (!MediaRecorder.isTypeSupported(mimeType)) {
								mimeType = "video/webm";
							}
						}
						console.log("Using MIME type:", mimeType);
						
						// 5. Create and start the media recorder
						mediaRecorder = new MediaRecorder(combinedStream, {
							mimeType: mimeType,
							videoBitsPerSecond: 3000000
						});
						
						recordedChunks = [];
						
						mediaRecorder.ondataavailable = (event) => {
							if (event.data.size > 0) {
								recordedChunks.push(event.data);
								console.log("Chunk recorded, size:", event.data.size);
							}
						};
						
						mediaRecorder.onstop = () => {
							stopTimer();
							isRecording = false;
							
							console.log("MediaRecorder stopped, chunks:", recordedChunks.length);
							
							if (recordedChunks.length === 0) {
								document.getElementById("errorMessage").textContent = "No data recorded. Please try again.";
								document.getElementById("startBtn").style.display = "block";
								document.getElementById("stopBtn").style.display = "none";
								document.getElementById("statusMessage").textContent = "Recording failed";
								window.opener.postMessage({ action: "recordingStopped", success: false }, "*");
								cleanup();
								return;
							}
							
							const blob = new Blob(recordedChunks, { type: mimeType });
							console.log("Recording complete, blob size:", blob.size);
							
							// Initiate automatic download
							const url = URL.createObjectURL(blob);
							const a = document.createElement("a");
							a.style.display = "none";
							a.href = url;
							a.download = "viphuddles-recording-" + new Date().toISOString() + ".webm";
							
							document.body.appendChild(a);
							a.click();
							
							// Upload recording to server for S3 storage
							document.getElementById("statusMessage").textContent = "Uploading recording to cloud storage...";
							
							// Get room ID from URL or parent window
							const urlParams = new URLSearchParams(window.location.search || window.name.split('Recording')[1] || '');
							console.log("URL search parameters:", urlParams.toString());
							
							// Try different methods to get the room_id
							let room_id = urlParams.get('room_id');
							console.log("Room ID from URL params:", room_id);
							
							// If not in URL, try window.opener
							if (!room_id && window.opener && window.opener.room_id) {
								room_id = window.opener.room_id;
								console.log("Room ID from window.opener:", room_id);
							}
							
							// Finally, check our own room_id property
							if (!room_id && window.room_id) {
								room_id = window.room_id;
								console.log("Room ID from window.room_id:", room_id);
							}
							
							// Fallback
							if (!room_id) {
								room_id = 'unknown';
								console.warn("No room_id found, using fallback:", room_id);
							}
							
							// Create a FormData instance
							const formData = new FormData();
							const filename = "recording-" + room_id + "-" + new Date().toISOString() + ".webm";
							formData.append("recording", blob, filename);
							formData.append("room_id", room_id);
							formData.append("session_id", urlParams.get('session_id') || "local-recording");
							
							// Send the recording to the server
							fetch('/wp-admin/admin-ajax.php?action=meeting_upload_recording', {
								method: 'POST',
								body: formData,
								credentials: 'same-origin'
							})
							.then(response => {
								if (!response.ok) {
									throw new Error("HTTP error! Status: " + response.status);
								}
								return response.json();
							})
							.then(data => {
								console.log("Recording uploaded to S3:", data);
								document.getElementById("statusMessage").textContent = "Recording saved to cloud storage";
								
								// Tell the parent window the recording is complete with both local and S3 URLs
								window.opener.postMessage({ 
									action: "recordingStopped", 
									success: true,
									s3Url: data.s3_presigned_url || null
								}, "*");
							})
							.catch(error => {
								console.error("Error uploading recording:", error);
								
								// First tell the parent the local recording was successful
								window.opener.postMessage({ 
									action: "recordingStopped", 
									success: true,
									s3Url: null
								}, "*");
								
								// Then try to show a more specific error message
								fetch('/wp-admin/admin-ajax.php?action=meeting_upload_recording_debug', {
									method: 'GET',
									credentials: 'same-origin'
								})
								.then(response => response.json())
								.then(debugInfo => {
									console.log("Debug info:", debugInfo);
									
									// Show appropriate message for missing AWS SDK
									if (error.message.includes("AWS S3 SDK") || 
										(debugInfo && debugInfo.methods_available && 
										!debugInfo.methods_available.uploadFileToS3)) {
										document.getElementById("statusMessage").textContent = 
											"S3 upload failed: Server missing AWS SDK";
									} else {
										document.getElementById("statusMessage").textContent = 
											"Local download complete (S3 upload failed)";
									}
								})
								.catch(e => {
									console.error("Could not get debug info:", e);
									document.getElementById("statusMessage").textContent = 
										"Local download complete (S3 upload failed)";
								});
							})
							.finally(() => {
								setTimeout(() => {
									document.body.removeChild(a);
									window.URL.revokeObjectURL(url);
								}, 100);
								
								cleanup();
							});
						};
						
						// Start recording with 1 second intervals
						mediaRecorder.start(1000);
						isRecording = true;
						startTimer();
						
						document.getElementById("startBtn").style.display = "none";
						document.getElementById("stopBtn").style.display = "block";
						document.getElementById("statusMessage").textContent = "Recording in progress";
						document.getElementById("errorMessage").textContent = "";
						
						window.opener.postMessage({ action: "recordingStarted" }, "*");
					} catch (err) {
						console.error("Recording error:", err);
						document.getElementById("errorMessage").textContent = "Error: " + err.message;
						document.getElementById("statusMessage").textContent = "Recording failed";
						window.opener.postMessage({ action: "recordingError", error: err.message }, "*");
						cleanup();
					}
				}
				
				// Set the button click handler to use the startRecording function
				document.getElementById("startBtn").onclick = startRecording;
				
				document.getElementById("stopBtn").onclick = () => {
					if (mediaRecorder && mediaRecorder.state !== "inactive") {
						mediaRecorder.stop();
					}
				};
				
				window.addEventListener("message", (event) => {
					if (event.data && event.data.action === "stopRecording") {
						console.log("Received stop recording message from parent");
						if (mediaRecorder && mediaRecorder.state !== "inactive") {
							mediaRecorder.stop();
						} else {
							// If mediaRecorder is already inactive, still notify the parent
							window.opener.postMessage({ action: "recordingStopped", success: false }, "*");
						}
					}
				});
				
				window.onbeforeunload = () => {
					if (mediaRecorder && mediaRecorder.state !== "inactive") {
						mediaRecorder.stop();
					}
					cleanup();
					window.opener.postMessage({ action: "recorderWindowClosed" }, "*");
				};
				
				// If user has chosen to skip instructions in the past, auto-start recording
				if (shouldSkipNextTime) {
					setTimeout(() => {
						startRecording();
					}, 500);
				}
			`;
			doc.body.appendChild(recorderScript);
			
			// Focus the popup window
			this.recorderWindow.focus();
		},
		
		// Handle messages from the recorder popup
		handleRecorderMessage(event) {
			console.log("Received message from recorder window:", event.data);
			
			if (!event.data || !event.data.action) {
				return;
			}
			
			switch(event.data.action) {
				case 'recordingStarted':
					console.log("Setting isRecording to true");
					this.isRecording = true;
					break;
					
				case 'recordingStopped':
					console.log("Setting isRecording to false");
					this.isRecording = false;
					if (event.data.success) {
						this.app.showSuccess("Recording saved successfully");
					}
					break;
					
				case 'recordingError':
					console.log("Recording error:", event.data.error);
					this.isRecording = false;
					this.app.showError("Recording error: " + event.data.error);
					break;
					
				case 'recorderWindowClosed':
					console.log("Recorder window closed");
					this.isRecording = false;
					break;
			}
		},
		toggleLivestream: async function() {
			if (this.meeting.livestream_state?.running) {
				this.meeting.rtmp_stopping = true
				try {
					await this.meeting.hmsActions.stopHLSStreaming()
					this.app.post('youtube/end_live_broadcast', { broadcast_id: this.broadcast_id, access_token: this.access_token })
				} catch (err) {
					console.error("failed to stop HLS", err)
				}
			} else if (this.meeting.livestream_state?.error) {
				console.error('error in livestream - ', this.meeting.livestream_state?.error)
			} else {
				this.livestream_starting = true
				let meetingUrl = window.location.href
				const params = {
					variants: [{
						meetingURL: meetingUrl+'record-guest', 
						// metadata: "landscape"
					}]
				}
				try {
					await this.meeting.hmsActions.startHLSStreaming(params)
					this.livestream_starting = false
				} catch (err) {
					console.error("failed to start hls", err)
					this.livestream_starting = false
				}
			}
		},
		toggleCobrowse: function() {
			if(this.meeting.isCobrowsing()) {
				// this.endCobrowse()		
				this.show_end_cobrowse_dialog = true
			} else {
				// this.startCobrowse()
				//stop screenshare if active
				let is_sharing = this.meeting.hmsStore.getState(selectIsLocalScreenShared)
				if(is_sharing)
					this.meeting.toggle_screenshare = !this.meeting.toggle_screenshare
				this.show_cobrowse_dialog = true
			}

		},
		loadRoom: function() {
			this.app.loadRoom(this.$vuetify, this.$router)
		},
		startCobrowse: function() {
			this.show_cobrowse_dialog = false
			this.starting_cobrowse = true
			setTimeout(() => {
				let cobrowse_url = this.cobrowse_url != '' ? this.cobrowse_url : 'https://google.com'

				// cobrowse url history
				let cobrowse_url_history = window.localStorage.getItem('cobrowse_url_history') ?? '[]'
				let urls = JSON.parse(cobrowse_url_history)
				urls.push(cobrowse_url)
				let uniqueUrls = [...new Set(urls)]
				window.localStorage.setItem('cobrowse_url_history', JSON.stringify(uniqueUrls))
				this.getCobrowseUrlHistory()

				// send request to start session
				this.app.post('meeting/cobrowse', {url: cobrowse_url})
					.then(async response => {
						this.starting_cobrowse = false
						if(response.data.id) {
							this.meeting.cobrowse_session = response.data
							const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
							const newMetadata = { ...metadata, cobrowse_session: this.meeting.cobrowse_session }
							await this.meeting.hmsActions.changeMetadata(newMetadata)
							// console.log("metadata init update", newMetadata)
						} else {
							console.error(response.data)
							let error = response.data?.url[0] ?? false
							if(error)
								this.app.showError(error)
						}
					})
					.catch(error => {
						this.starting_cobrowse = false
						console.error(error)
					})
					.finally(() => {
						this.starting_cobrowse = false
					})
			}, 100)
		},
		endCobrowse: function() {
			this.show_end_cobrowse_dialog = false
			this.ending_cobrowse = true
			this.app.post('meeting/cobrowse/end', {session_id: this.meeting.cobrowse_session.id})
				.then(response => {
					
				})
				.catch(error => {
					this.error(error)
					this.app.showError('Oops! Something went wrong.')
				})
				.finally(async () => {
					this.ending_cobrowse = false
					this.meeting.cobrowse_session = {}
					const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
					const newMetadata = { ...metadata, cobrowse_session: {} }
					await this.meeting.hmsActions.changeMetadata(newMetadata)
				})
		},
		leave: async function() {
			// Stop recording if active
			if (this.isRecording && this.recorderWindow && !this.recorderWindow.closed) {
				this.recorderWindow.postMessage({ action: 'stopRecording' }, '*');
			}

			if(this.meeting.local_peer.roleName == 'host' && this.meeting.isCobrowsing()) {
				let hosts = 0
				this.meeting.peers.forEach(peer => {
					if(peer.roleName == 'host')
						hosts++
				})
				if(hosts == 1)
					await this.endCobrowse()
			}
			this.meeting.leave()
		},
		sendMetaData: async function() {
			if(this.meeting.local_peer.roleName != 'host')
				return

			const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
			const newMetadata = { ...metadata, random: Math.random() }
			await this.meeting.hmsActions.changeMetadata(newMetadata)
			// console.log("metadata init update", newMetadata)
			
		},
		toggleScreenshare() {
			if(this.meeting.is_whiteboard_active) {
				this.toggleWhiteboard()
				return
			}
			if(this.meeting.video_playlist.length > 0) {
				this.meeting.hmsActions.videoPlaylist.stop()
				this.meeting.hmsActions.videoPlaylist.clearList()
				return
			}
			if(this.meeting.audio_playlist.length > 0) {
				this.meeting.hmsActions.audioPlaylist.stop()
				this.meeting.hmsActions.audioPlaylist.clearList()
				return
			}
			if(this.meeting.isCobrowsing()){
				let is_sharing = this.meeting.hmsStore.getState(selectIsLocalScreenShared)
				if(!is_sharing)
					this.app.showError("You must end your cobrowsing session before enabling screensharing.")
				else
					this.meeting.toggle_screenshare = !this.meeting.toggle_screenshare
			} else {
				this.meeting.toggle_screenshare = !this.meeting.toggle_screenshare
			}
			this.show_share_dialog = false
		},
		async toggleWhiteboard() {
			if(!this.meeting.is_whiteboard_active) {
				// this.show_whiteboard_dialog = true	
				this.startWhiteboardSession()
			} else {
				this.meeting.is_whiteboard_active = false
				this.meeting.whiteboard_code = ""

				const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
				const newMetadata = { ...metadata, whiteboard_code: "" }
				await this.meeting.hmsActions.changeMetadata(newMetadata)
			}
			this.show_share_dialog = false
		},
		startWhiteboardSession() {
			this.show_whiteboard_dialog = false
			this.meeting.is_whiteboard_active = true
			
			setTimeout(async () => {
				this.meeting.whiteboard_code = 'user-whiteboard-'+this.user.userdata.ID+'-'+this.app.room.ID
				// console.log("whiteboard_code:", this.meeting.whiteboard_code)
				this.meeting.activateWhiteboard()

				const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
				const newMetadata = { ...metadata, whiteboard_code: this.meeting.whiteboard_code }
				await this.meeting.hmsActions.changeMetadata(newMetadata)
			}, 100)
		},
		createLiveBroadcast() {
			if(this.livestream_title == '') {
				this.livestream_title_errors = 'Title is required'
				return
			}
			this.livestream_title_errors = ""
			this.connecting_to_youtube = true
			this.livestream_status_message = "Connecting to youtube."
			this.app.post('youtube/create_live_broadcast', { title: this.livestream_title, description: this.livestream_description, privacy: this.livestream_privacy })
			.then(response => {
				console.log("resp:", response.data)
				if(response.data.auth_url){
					// create popup window for youtube authentication
					this.openPopupWindow(response.data.auth_url)
					return
				} else if (response.data.rtmp_url) {
					this.connecting_to_youtube = false
					this.livestream_status_message = "Starting livestream."
					this.rtmp[0].url = response.data.rtmp_url
					this.rtmp[0].key = response.data.rtmp_key
					this.broadcast_id = response.data.broadcast_id
					this.access_token = response.data.access_token
					this.toggleRecord(true)
				} else if (response.data.error) {

				}
			})
		},
		openPopupWindow(url) {
			// define the popup window dimensions
			var width = 700;
			var height = 800;
			var left = window.screen.width / 2 - width / 2;
			var top = window.screen.height / 2 - height / 2;

			// create a popup window for authentication
			var popup = window.open(url, '_blank', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);

			// listen for the popup window to close
			let g = this
			var timer = setInterval(function() {
				if (popup && popup.closed) {
					clearInterval(timer);
					g.createLiveBroadcast()
				}
			}, 1000);

		},
		handleBeforeUnload() {
			// Stop recording if active when closing tab/browser
			if (this.isRecording && this.recorderWindow && !this.recorderWindow.closed) {
				this.recorderWindow.postMessage({ action: 'stopRecording' }, '*');
			}
		},
	},
	watch: {
		'recording_state.browser.running': function(newV) {
			if(newV)
				this.meeting.recording_starting = false
		},
		'meeting.livestream_state.running': function(newV, oldV) {
			console.log('watch meeting.livestream_state.running', newV, oldV)
		},
		'meeting.toggle_auto_record': function(newV, oldV) {
			console.log('toggle_auto_record', newV, oldV)
			if(newV && !this.meeting.recording_state?.browser?.running)
				this.toggleRecord()
		}
	}
};
</script>

<style>
#wpadminbar {
	display: none;
}
body::-webkit-scrollbar {
    display: none;
}
</style>
